var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"doc-collection-wrap"},[_c('sidebar',{on:{"updateHtml":_vm.updateHtml}}),_c('preview',{attrs:{"html":_vm.html}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }